
<template>
    <footer class="footer bg-dark-footer relative text-gray-200 dark:text-gray-200">
        <div class="container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="py-[60px] px-0">
                        <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                            <div class="lg:col-span-4 md:col-span-12">
                                <Link :href="route('home')" class="text-[22px] focus:outline-none">
                                    <logo class="help-desk-logo" />
                                </Link>
                                <p class="mt-6 text-gray-300" v-html="footer_text"></p>
                            </div><!--end col-->

                            <div class="lg:col-span-2 md:col-span-4">
                                <h5 class="tracking-[1px] text-gray-100 font-semibold">Company</h5>
                                <ul class="list-none footer-list mt-6">
<!--                                    <li><Link :href="route('about')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> About us</Link></li>-->
                                    <li v-if="!!this.enable_option && this.enable_option.service" class="mt-[10px]"><a :href="route('our_services')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Services</a></li>
<!--                                    <li class="mt-[10px]"><Link :href="route('team')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Team</Link></li>-->
                                    <li v-if="!!this.enable_option && this.enable_option.blog" class="mt-[10px]"><a :href="route('blog')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Blog</a></li>
                                    <li v-if="!!this.enable_option && this.enable_option.show_login" class="mt-[10px]"><a :href="route('login')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Login</a></li>
                                </ul>
                            </div><!--end col-->

                            <div class="lg:col-span-3 md:col-span-4">
                                <h5 class="tracking-[1px] text-gray-100 font-semibold">Usefull Links</h5>
                                <ul class="list-none footer-list mt-6">
                                    <li><a :href="route('terms_service')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Terms of Services</a></li>
                                    <li class="mt-[10px]"><a :href="route('privacy')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Privacy Policy</a></li>
                                    <li v-if="!!this.enable_option && this.enable_option.kb" class="mt-[10px]"><a :href="route('kb')" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Knowledge Base</a></li>
                                </ul>
                            </div><!--end col-->

                            <div class="lg:col-span-3 md:col-span-4">
                                <h5 class="tracking-[1px] text-gray-100 font-semibold">Newsletter</h5>
                                <p class="mt-6">Receive the latest tips via email.</p>
                                <form @submit.prevent="subscribe">
                                    <div class="grid grid-cols-1">
                                        <div class="foot-subscribe my-3">
                                            <label class="form-label">Write your email <span class="text-red-600">*</span></label>
                                            <div class="form-icon relative mt-2">
                                                <icon class="w-4 w-4 absolute top-3 left-4 z-1 fill-gray-100" name="email" />
                                                <input type="email" v-model="form.email" class="form-input bg-gray-800 border border-gray-800 text-gray-100 pl-12 focus:shadow-none" placeholder="Email" name="email" required="">
                                            </div>
                                        </div>

                                        <loading-button :loading="form.processing" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md justify-center" type="submit">{{ __('Subscribe') }}</loading-button>
                                    </div>
                                </form>
                            </div><!--end col-->
                        </div><!--end grid-->
                    </div><!--end col-->
                </div>
            </div><!--end grid-->
        </div><!--end container-->

        <div class="py-[30px] px-0 border-t border-slate-800">
            <div class="container text-center">
                <div class="grid md:grid-cols-2 items-center">
                    <div class="md:text-left text-center">
                        <p class="mb-0" v-html="footer_content.copyright"></p>
                    </div>

                </div><!--end grid-->
            </div><!--end container-->
        </div>
    </footer>
</template>

<script>
import Logo from '@/Shared/Logo'
import Icon from '@/Shared/Icon'
import LoadingButton from '@/Shared/LoadingButton'
import { Link } from '@inertiajs/inertia-vue3'
export default {
    components: {
        Logo, LoadingButton, Link, Icon
    },
    props: {
        footer: Object,
    },
    data() {
        return {
            footer_content: JSON.parse(this.footer.html),
            footer_text: JSON.parse(this.footer.html).text || 'Start working with HelpDesk that can provide everything you need to generate awareness, drive traffic, connect.',
            form: this.$inertia.form({
                email: '',
            }),
            enable_option: {},
        }
    },
    methods: {
        subscribe() {
            this.form.post(this.route('subscribe.news'))
            this.form.email = ''
        },
    },
    created() {
        if(this.$page.props.enable_options){
            let options = JSON.parse(this.$page.props.enable_options.value)
            options.forEach(option=>{
                this.enable_option[option.slug] = !!option.value
            })
        }
    }

}
</script>
